import { render } from "./ReturnReasonCreateComponent.vue?vue&type=template&id=1cd5b13a"
import script from "./ReturnReasonCreateComponent.vue?vue&type=script&lang=js"
export * from "./ReturnReasonCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ReturnReason/ReturnReasonCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cd5b13a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cd5b13a', __exports__)) {
    api.reload('1cd5b13a', __exports__)
  }
  
  module.hot.accept("./ReturnReasonCreateComponent.vue?vue&type=template&id=1cd5b13a", () => {
    api.rerender('1cd5b13a', render)
  })

}


export default __exports__